import * as CL from '@design-system/component-library';
import { useState } from 'react';
import { ELISA_ID_MIGRATION_DEADLINE } from '../../common/constants/commonConstants.js';
import { dsClass } from '../../common/constants/dsClasses.js';
import {
  activateLaterMsg,
  activateNewElisaIdMsg,
  elisaIdMigrationAccountStopWorkingMsg,
  elisaIdMigrationAccountsDiscontinuedOnMsg,
  elisaIdMigrationActivateBeforeDateMsg,
  elisaIdMigrationBenefitsMsg,
  elisaIdMigrationNoPasswordMsg,
  elisaIdMigrationNoPersonalIdMsg,
  elisaIdMigrationOtherServicesMsg,
  elisaIdMigrationStartActivationMsg,
  formatDate,
  hereMsg,
  personalUserAccountMsg,
  proceedToAuthenticationMsg,
  t,
} from '../../common/i18n/index.js';
import { useAuth } from '../../public/site/AuthProvider.js';
import { getMigrationSkipped, setMigrationSkipped } from '../../selfservice/common/localStorageUtils.js';
import { Modal } from '../Modal/Modal.js';
import { ModalButtons } from '../Modal/ModalButtons.js';

import './ElisaIdMigrationModal.scss';

export interface ElisaIdMigrationModalProps {
  canSkip: boolean;
  userEmail?: string;
}

export const ElisaIdMigrationModal = ({ canSkip, userEmail }: ElisaIdMigrationModalProps) => {
  const { prepareElisaIdLogin } = useAuth();
  const [dismissed, setDismissed] = useState(getMigrationSkipped);
  const [isLoading, setIsLoading] = useState(false);

  if (dismissed) {
    return null;
  }

  const onSkip: () => void = () => {
    setMigrationSkipped();
    setDismissed(true);
  };

  const formattedDeadline = formatDate(ELISA_ID_MIGRATION_DEADLINE);
  return (
    <Modal
      heading={t.F2S0(activateNewElisaIdMsg)}
      icon={<div className="of-elisa-id-migration-modal__icon" />}
      size="m"
      className="of-elisa-id-migration-modal__dialog"
    >
      <div className={`of-elisa-id-migration-modal ${dsClass.DISPLAY_FLEX}`}>
        <p>{t.LGO7(elisaIdMigrationBenefitsMsg)}:</p>
        <CL.List
          items={[
            t.LK4J(personalUserAccountMsg),
            t.N3XM(elisaIdMigrationNoPasswordMsg),
            t.NCDC(elisaIdMigrationOtherServicesMsg),
          ]}
        />
        {userEmail && <p>{t.O06Y(elisaIdMigrationAccountStopWorkingMsg, userEmail)}</p>}
        {formattedDeadline && (
          <p>
            {t.PRM5(elisaIdMigrationAccountsDiscontinuedOnMsg)} <strong>{formattedDeadline}</strong>
            {t.SG1R(elisaIdMigrationActivateBeforeDateMsg)}
          </p>
        )}
        <p>
          <strong>{t.TX9O(elisaIdMigrationStartActivationMsg)}</strong> {t.UOFI(elisaIdMigrationNoPersonalIdMsg)}
          <CL.Button color="link-button" onClick={() => prepareElisaIdLogin()}>
            {t.OP1Q(hereMsg)}
          </CL.Button>
          .
        </p>
      </div>
      <ModalButtons>
        {canSkip && (
          <CL.Button color="link" size="l" onClick={onSkip}>
            {t.XDN7(activateLaterMsg)}
          </CL.Button>
        )}
        <CL.Button
          color="primary"
          size="l"
          loading={isLoading}
          disabled={isLoading}
          onClick={() => {
            setIsLoading(true);
            prepareElisaIdLogin({ migrate: true, register: true });
          }}
        >
          {t.ZUFX(proceedToAuthenticationMsg)}
        </CL.Button>
      </ModalButtons>
    </Modal>
  );
};
